import React from 'react'
import { PaymentSummaryType } from './types'
import { PotentialClientProgress } from './components/PotentialClientProgress'
import { ActiveClientProgress } from './components/ActiveClientProgress'

interface PaymentProgressProps {
    paymentSummary: PaymentSummaryType
    isAnyDelivered?: boolean
    showMilestones?: boolean
}

export const PaymentProgress = ({
    paymentSummary,
    isAnyDelivered = false,
    showMilestones = false
}: PaymentProgressProps) => {
    const { allEnrollment, ...remainingSummary } = paymentSummary

    if (allEnrollment === 0) {
        return (
            <PotentialClientProgress
                paymentSummary={remainingSummary as PaymentSummaryType}
            />
        )
    }

    return (
        <ActiveClientProgress
            paymentSummary={paymentSummary}
            isAnyDelivered={isAnyDelivered}
            showMilestones={showMilestones}
        />
    )
}
